import _unionBy from "lodash/unionBy";
import { allCountries } from '@atlaskit/select/dist/esm/data/countries';
const countriesOverride = [{
  icon: '🇺🇲',
  name: 'United States of America',
  abbr: 'US',
  code: '1',
  suggested: true
}, {
  icon: '🇧🇳',
  name: 'Brunei',
  abbr: 'BN',
  code: '673'
}, {
  icon: '🇨🇩',
  name: "Congo (Democratic People's Republic)",
  abbr: 'CG',
  code: '243'
}, {
  icon: '🇨🇬',
  name: 'Congo (Republic of)',
  abbr: 'CD',
  code: '242'
}, {
  icon: '🇨🇮',
  name: "Cote d'Ivoire (Ivory Coast)",
  abbr: 'CI',
  code: '225'
}, {
  icon: '🇭🇷',
  name: 'Croatia (Hrvatska)',
  abbr: 'HR',
  code: '385'
}, {
  icon: '🇫🇰',
  name: 'Falkland Islands',
  abbr: 'FK',
  code: '500'
}, {
  icon: '🇭🇲',
  name: 'Heard and McDonald Islands',
  abbr: 'HM',
  code: '672'
}, {
  icon: '🇮🇷',
  name: 'Iran',
  abbr: 'IR',
  code: '98'
}, {
  icon: '🇰🇵',
  name: 'Korea (North)',
  abbr: 'KP',
  code: '850'
}, {
  icon: '🇰🇷',
  name: 'Korea (South)',
  abbr: 'KR',
  code: '82'
}, {
  icon: '🇱🇦',
  name: 'Laos',
  abbr: 'LA',
  code: '856'
}, {
  icon: '🇲🇴',
  name: 'Macau',
  abbr: 'MO',
  code: '853'
}, {
  icon: '🇲🇰',
  name: 'Macedonia',
  abbr: 'MK',
  code: '389'
}, {
  icon: '🇫🇲',
  name: 'Micronesia',
  abbr: 'FM',
  code: '691'
}, {
  icon: '🇲🇩',
  name: 'Moldova',
  abbr: 'MD',
  code: '373'
}, {
  icon: '🇲🇵',
  name: 'Northern Marianas Islands',
  abbr: 'MP',
  code: '1-670'
}, {
  icon: '🇵🇸',
  name: 'Palestinian Territory',
  abbr: 'PS',
  code: '970'
}, {
  icon: '🇸🇰',
  name: 'Slovak Republic',
  abbr: 'SK',
  code: '421'
}, {
  icon: '🇸🇯',
  name: 'Svalbard and Jan Mayen Islands',
  abbr: 'SJ',
  code: '47'
}, {
  icon: '🇸🇾',
  name: 'Syria',
  abbr: 'SY',
  code: '963'
}, {
  icon: '🇹🇼',
  name: 'Taiwan',
  abbr: 'TW',
  code: '886'
}, {
  icon: '🇹🇿',
  name: 'Tanzania',
  abbr: 'TZ',
  code: '255'
}, {
  icon: '🇻🇦',
  name: 'Vatican City',
  abbr: 'VA',
  code: '379'
}, {
  icon: '🇻🇬',
  name: 'Virgin Islands (US)',
  abbr: 'VG',
  code: '1-284'
}, {
  icon: '🇻🇮',
  name: 'Virgin Islands (US)',
  abbr: 'VI',
  code: '1-340'
}, {
  icon: '🇼🇫',
  name: 'Wallis and Futuna Islands',
  abbr: 'WF',
  code: '681'
}];
export const countries = _unionBy(countriesOverride, allCountries, 'abbr');
export const getCountryByIsoCode = isoCode => countries.find(({
  abbr
}) => abbr.toLowerCase() === isoCode.toLowerCase());